import React, { useEffect, useState } from 'react';
import { TransactionHistoryRow } from './Row';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { RecordsTable } from 'dyl-components';
import { TransactionHistoryHeader } from './Header';
import subscriptionActions from "actions/subscription";
import QuoteBuilderProvider from 'shared/context/QuoteBuilderProvider';
import QuoteBuilderModal from 'shared/modals/QuoteBuilderModal';

const TransactionHistoryTable = ({ onOpenAddContactModal }) => {
    const [params] = useSearchParams();
    const navigate = useNavigate();
    const dispatch = useDispatch()

    const account_id = useSelector(state => state.auth.customer_id);

    const [filters, setFilters] = useState({
        invoice_status: params.get('invoice_status')?.split(','),
    })

    const onFilter = async (_, { name, value }) => {
        setFilters({
            ...filters,
            [name]: value
        });
    }
    const onPageChange = (_, { activePage }) => {
        const query = new URLSearchParams(params);
        query.set('page', activePage);
        const query_string = query.toString();
        navigate(`/settings/billing/transaction-history${query_string ? `?${query_string}` : ''}`);
    }

    const {data:transactions = [] , count = 0, isReadingTransactionHistory } = useSelector(state => {
        return {
            ...(state.subscription.transaction_history || {}),
            isReadingTransactionHistory : state.subscription.isReadingTransactionHistory
        } || {}
    });
    useEffect(() => {
        const query = new URLSearchParams(params);
        const { invoice_status } = filters;
        if (invoice_status?.length > 0) {
            query.set('invoice_status', invoice_status.join(','));
        } else {
            query.delete('invoice_status');
        }
        const query_string = query.toString();
        navigate(`/settings/billing/transaction-history${query_string ? `?${query_string}` : ''}`);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filters])

    useEffect(() => {
        const queryParameters = {
            page: 1,
            limit: 25,
            ...Object.fromEntries(params),
            isAdmin:true
        }

        dispatch(subscriptionActions.getTransactionHistory(account_id,queryParameters));
    }, [params, account_id, dispatch]);

    const customer_id = useSelector(state => state.auth.customer_id);

    return (
        <QuoteBuilderProvider>
            <RecordsTable
                tableBodyClassName='TransactionHistoryTable'
                isTableLoading={isReadingTransactionHistory}
                isSearchResultEmpty={count === 0 && (params.get('invoice_status'))}
                isTableEmpty={count === 0 && !(params.get('invoice_status'))}
                TableHeader={<TransactionHistoryHeader onFilter={onFilter} />}
                TableRows={transactions.map(transaction => (
                    <TransactionHistoryRow key={transaction.id} transaction={transaction} account_id={account_id} />
                ))}
                noBorder
                recordsCount={count}
                activePage={params.get('page')}
                onPageChange={onPageChange}
                recordsName='Transaction History'
                onClick={onOpenAddContactModal}
                emptyListTitle={'No Transaction History found.'}
                emptySubtitle=' '
            />
            <QuoteBuilderModal 
                account_id={customer_id}
            />
        </QuoteBuilderProvider>
    )
}

export default TransactionHistoryTable;
